export function formatRelativeTime(iso: string): string {
  const date = new Date(iso);
  const diffMs = date.getTime() - Date.now();
  const diffSec = Math.round(diffMs / 1000);
  const divisions: [Intl.RelativeTimeFormatUnit, number][] = [
    ['second', 1],
    ['minute', 60],
    ['hour', 3600],
    ['day', 86400],
    ['week', 604800],
    ['month', 2629800],
    ['year', 31557600],
  ];
  const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

  let unit: Intl.RelativeTimeFormatUnit = 'second';
  let value = diffSec;
  for (let i = divisions.length - 1; i >= 0; i--) {
    const [u, secondsInUnit] = divisions[i];
    if (Math.abs(diffSec) >= secondsInUnit || u === 'second') {
      unit = u;
      value = Math.round(diffSec / secondsInUnit);
      break;
    }
  }
  return rtf.format(value, unit);
}

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}

export const priorityColor: Record<string, string> = {
  Highest: 'bg-rose-500',
  High: 'bg-orange-500',
  Medium: 'bg-amber-400',
  Low: 'bg-sky-400',
  Lowest: 'bg-slate-400',
};

export const statusCategoryColor: Record<string, string> = {
  new: 'bg-slate-400',
  indeterminate: 'bg-amber-400',
  done: 'bg-pulse-500',
};
